import React, { useState, useEffect } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import { inRoomDiningItemsSelector } from '../../../servicesSlice';
import { useSelector } from 'react-redux';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import CustomMultiSelect from './../../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const ItemCreateUpsell = (props) => {
  const { formData, setFormData, onChangeRadioButton, selectedItemId } = props;
  const originalItems = useSelector(inRoomDiningItemsSelector);
  const [itemList, setItemList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  useEffect(() => {
    if (selectedItemId) {
      setItemList(originalItems.filter((item) => item.id !== selectedItemId));
    } else {
      setItemList(originalItems);
    }
  }, [originalItems, selectedItemId]);

  const onSearchItemList = async (searchItem) => {
    setSearchValue(searchItem);
    const filtered = originalItems?.filter(
      (item) =>
        item?.id !== selectedItemId &&
        item?.name?.toLowerCase()?.includes(searchItem?.toLowerCase()),
    );
    setItemList(filtered);
  };

  const RenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
      const item = originalItems.find((ild) => ild.id === itemData);
      return item?.name;
    });
    const formItem = { ...formData.items };
    formItem.fieldName = `${selectedValue.lenght} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  const onChangeItem = (e) => {
    const upsellItems = { ...e };
    e.fieldName = `${e.value.length} selected`;
    setFormData({ upsellItems });
  };

  const onChangeUpsellStatus = (e, fieldName) => {
    formData.upsellItems.validations = e.target.value === 'active' ? ['required', 'maxLength'] : [];
    onChangeRadioButton(e, fieldName);
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4'>
      <div className='row'>
        <h4 className='tab-title'>Upsell Items</h4>
        <div className='col-md-12 mb-3'>
          <RadioGroup
            row
            aria-label={formData.upsellStatus.fieldName}
            onChange={(e) => {
              onChangeUpsellStatus(e, 'upsellStatus');
            }}
            value={formData.upsellStatus.value}
            name={formData.upsellStatus.fieldName}
            className='document-type mb-3'
          >
            <FormControlLabel
              value='active'
              control={<Radio color='primary' />}
              label='Active'
              className='col-md-4'
            />
            <FormControlLabel
              value='inactive'
              control={<Radio color='primary' />}
              label='Inactive'
              className='col-md-4'
            />
          </RadioGroup>
        </div>
      </div>
      {formData.upsellStatus.value === 'active' && (
        <div className='col-md-12 row'>
          <div className='col-md-6'>
            <CustomMultiSelect
              item={formData.upsellItems}
              options={itemList}
              hideNullOption={true}
              valueField='id'
              labelField='name'
              handleInputChange={(e) => onChangeItem(e)}
              isSearchable={true}
              getSearchInput={onSearchItemList}
              searchValue={searchValue}
              searchPlaceholder='Search'
              isCustomDisplay={true}
              renderCustomDisplay={RenderCustomDisplay}
            />
          </div>
          <div className='col-md-1' style={{ margin: '20px' }}>
            <CustomToolTip title='Maximum selection of 5 items' placement='right-end'>
              <InfoIcon fontSize='small' />
            </CustomToolTip>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemCreateUpsell;
